import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { GeneralQueryErrorResultCreator, MissingQueryDataResultCreator, NonOkQueryResultCreator } from '../../graphql-result';
import { ResponseCacheProviderResolver } from '../../response-cache-provider';
/** The requester to make query operation to App Recommendations API via AGG
 *
 * Currently, App Recommendations Service has only a single query (and we only use a single query), which doesn't return any Query errors
 * @see {@link https://developer.atlassian.com/platform/graphql-gateway/standards/query-error/} for more about query errors
 * The query error checking is skipped for now, but it can be added in the future if needed
 */
var Requester = /*#__PURE__*/function () {
  function Requester(broker) {
    _classCallCheck(this, Requester);
    this.broker = broker;
  }

  /**
   * Fetches the response by the given request from the cache or the API
   * the cache config is optional, if not provided, the response will not be cached
   *
   * @param request The request to fetch the response from
   * @param cacheConfig The cache configuration to use
   * @returns The query result
   */
  _createClass(Requester, [{
    key: "fetch",
    value: function fetch(request) {
      var _this = this;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        cacheConfig = _ref.cacheConfig;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var _json$data;
          var response, json, schemaResponse, queryRes;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getResponse(request, cacheConfig);
              case 2:
                response = _context.sent;
                if (response.ok) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", reject(new NonOkQueryResultCreator(response).makeQueryResult()));
              case 5:
                _context.next = 7;
                return response.json();
              case 7:
                json = _context.sent;
                if (!json.errors) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return", reject(new GeneralQueryErrorResultCreator(json.errors).makeQueryResult()));
              case 10:
                schemaResponse = json === null || json === void 0 || (_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.growthRecommendations;
                queryRes = _this.broker.extract(schemaResponse); // Undefined is not expected as a valid response from GraphQL
                if (!(queryRes === undefined)) {
                  _context.next = 14;
                  break;
                }
                return _context.abrupt("return", reject(new MissingQueryDataResultCreator(response).makeQueryResult()));
              case 14:
                return _context.abrupt("return", resolve(_this.broker.getSuccessResultCreator(response, queryRes).makeQueryResult()));
              case 15:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }

    /**
     * Fetches the response by tha given request from the cache or the API
     * the cache config is optional, if not provided, the response will not be cached
     *
     * @param request The request to fetch the response from
     * @param cacheConfig The cache configuration to use
     * @returns The response from the request
     */
  }, {
    key: "getResponse",
    value: (function () {
      var _getResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, cacheConfig) {
        var cacheProvider, cachedResponse, clonedRequest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cacheProvider = ResponseCacheProviderResolver.resolve(cacheConfig);
              _context2.next = 3;
              return cacheProvider.get(request);
            case 3:
              cachedResponse = _context2.sent;
              if (!cachedResponse) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", cachedResponse);
            case 6:
              // Clone the request before it being used to be able to use it multiple times
              clonedRequest = request.clone();
              return _context2.abrupt("return", fetch(request).then(function (response) {
                // Cache response only if the response is ok
                if (response.ok) {
                  cacheProvider.set(clonedRequest, response.clone());
                }
                return response;
              }));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getResponse(_x3, _x4) {
        return _getResponse.apply(this, arguments);
      }
      return getResponse;
    }())
  }]);
  return Requester;
}();
export { Requester as default };